import React, { useState } from 'react'
import { TableProjectLineProps } from './TableProjectLine.types'
import styles from './TableProjectLine.module.scss'
import cl from 'classnames'
import { ExpandButton, TableBodyLine, Text1 } from 'components/shared'
import { WarningMessage } from 'components'
import { personProjectsTableWidths } from '../ProjectsSection.types'
import { PersonProjectsTableSortProps, PERSON_PROJECTS_TABLE_STORE } from 'store'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { isProjectPublished } from 'utilities'

const TableProjectLineComponent = (props: TableProjectLineProps) => {
  const {
    project,
    expandLevel = 0,
    [PERSON_PROJECTS_TABLE_STORE]: {
      isColumnMarked,
      getRolesByProjectId
    }
  } = props

  const isExpandable = Boolean(project.children && project.children.length)
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className={cl(styles.container, {
      [cl(styles.expandedTopRight, styles.expandedBottomLeft)]:
        isExpanded && expandLevel === 0
    })}
    >
      <TableBodyLine
        cells={[
          {
            // widthPercentage: personProjectsTableWidths.name,
            widthPx: personProjectsTableWidths.name,
            isColumnMarked: isColumnMarked(PersonProjectsTableSortProps.NAME),
            style: { paddingLeft: 24 + expandLevel * 10 },
            children: (
              <>
                {isExpandable && (
                  <ExpandButton
                    isExpanded={isExpanded}
                    onClick={() => setIsExpanded(s => !s)}
                    style={{ marginLeft: expandLevel * 20 }}
                  />
                )}
                <Text1
                  bold
                  overflowEllipsis
                  style={
                    !isExpandable && expandLevel
                      ? { marginLeft: 24 + expandLevel * 10 }
                      : undefined
                  }
                >
                  {project.name}
                </Text1>
                <WarningMessage
                  object={project}
                  objectType='project'
                />
              </>
            )
          },
          {
            // widthPercentage: personProjectsTableWidths.type,
            widthPx: personProjectsTableWidths.type,
            isColumnMarked: isColumnMarked(PersonProjectsTableSortProps.TYPE),
            children: project.type
          },
          {
            // widthPercentage: personProjectsTableWidths.role,
            widthPx: personProjectsTableWidths.role,
            isColumnMarked: isColumnMarked(PersonProjectsTableSortProps.ROLE),
            children: getRolesByProjectId(project.id)
          },
          {
            // widthPercentage: personProjectsTableWidths.genre,
            widthPx: personProjectsTableWidths.genre,
            isColumnMarked: isColumnMarked(PersonProjectsTableSortProps.GENRE),
            children: project.genresAsString
          },
          {
            // widthPercentage: personProjectsTableWidths.published,
            widthPx: personProjectsTableWidths.published,
            children: isProjectPublished(project.status) ? 'Yes' : 'No',
            style: {
              color: isProjectPublished(project.status)
                ? styles.primary
                : styles.primaryContent
            }
          }
        ]}
      />
      {isExpanded && (
        project.children.map(p => (
          <TableProjectLine key={p.id} project={p} expandLevel={expandLevel + 1} />
        ))
      )}
    </div>
  )
}

const TableProjectLine = inject(
  PERSON_PROJECTS_TABLE_STORE
)(observer(TableProjectLineComponent))
export { TableProjectLine }
